'use client'

import Image from 'next/image'
import {useEffect, useRef} from 'react'
import s from './style.module.scss'
import useSearchStore from '@app/components/search-section/store/search-store'
import clsx from 'clsx'
import useSearch from '@app/components/search-section/search-bar/use-search'
import triggerAnalytics from '@gamezop/analytics-sdk/client/trigger-analytics'
import {HeaderEvent} from '@app/components/header/analytics/events'
import {LanguageCodes} from '@app/i18n/settings'
import {useTagsPageAnalytics} from '@app/[lang]/(common-header-footer)/tags/(tag-page)/[tagName]/[tagId]/get-tag-page-analytics/tag-page-analytics-context'

type Props = {
  placeholderText: string
  lang: LanguageCodes
}

const SearchBarDesktopClient = ({placeholderText, lang}: Props) => {
  const {isFocused, setFocused} = useSearchStore()
  const inputRef = useRef<HTMLInputElement>(null)
  const {showSearchBtn, handleSearch, resetSearch} = useSearch()
  const {tagAnalyticsData} = useTagsPageAnalytics()

  useEffect(() => {
    // Focus input if the focused state is true
    if (isFocused && inputRef.current) {
      inputRef.current.focus()
      triggerAnalytics(HeaderEvent.SearchButtonClicked, tagAnalyticsData).sendAll()
    }
  }, [isFocused])

  return (
    <>
      <form className={s.search_bar_container} onReset={resetSearch}>
        <div className={s.search_bar}>
          {/* left search section */}
          <div className={s.search_bar_left_container}>
            <Image
              src='https://static.gamezop.com/comet/assets/img2/search.svg'
              alt='search button'
              width={18}
              height={18}
              className={s.search_icon}
            />
            <input
              ref={inputRef}
              type='search'
              placeholder={placeholderText}
              className={clsx(s.search_bar_input, {[s.focused]: isFocused})}
              onChange={handleSearch}
              onFocus={() => {
                setFocused(true)
              }}
            />
          </div>

          {/* right search section */}
          {!showSearchBtn && (
            <button className={s.clear_button} type='reset'>
              <Image
                src='https://static.gamezop.com/comet/assets/img2/close.svg'
                alt='close button'
                width={12}
                height={12}
                className={s.search_icon}
              />
            </button>
          )}
        </div>
      </form>
    </>
  )
}

export default SearchBarDesktopClient
